import { z } from 'zod'

// Response schema for refresh token endpoint
export const refreshResponseSchema = z.object({
  access_token: z.string(),
})

export type RefreshResponseDto = z.infer<typeof refreshResponseSchema>
